import api from "../../axiosConfig";


export const saveCertificate = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('patient-certificates/add', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getcertificateTypes = async () => {
  try {
    const response = await api.get('certificate-template-types/all', {
   
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};


